/* RodentRx Quiz Engine — extracted from sections/rodentrx-landing.liquid
   Requires window.VARIANT_MAP_BY_COUNT and window.PRODUCT_URL to be set before load. */
(function() {
  var QUESTIONS = {
    Q1: {
      text: "What's going on at your home right now?",
      options: [
        { id: 'A', text: 'I just saw a mouse, droppings, or other evidence — I have an active problem right now' },
        { id: 'B', text: "I had mice before and I don't want it to happen again" },
        { id: 'C', text: "I haven't had mice but I'm concerned — new home, new season, or a neighbor just had a problem" },
        { id: 'D', text: "I've tried things before — traps, sprays, other devices — and the problem keeps coming back" }
      ], multi: false
    },
    Q_STATE: {
      text: 'What state do you live in?',
      type: 'dropdown',
      options: [
        'Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia',
        'Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland',
        'Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey',
        'New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina',
        'South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming','District of Columbia'
      ]
    },
    Q2: {
      text: 'What type of home do you live in?',
      options: [
        { id: 'A', text: 'Single-family house (standalone home, no shared walls)' },
        { id: 'B', text: 'Townhouse or duplex (attached to at least one neighboring unit)' },
        { id: 'C', text: 'Apartment or condo (multi-unit building)' },
        { id: 'D', text: 'Mobile or manufactured home' }
      ], multi: false
    },
    Q3: {
      text: 'Do you have a garage?',
      options: [
        { id: 'A', text: 'No garage' },
        { id: 'B', text: '1-car garage (1 bay, 1 garage door)' },
        { id: 'C', text: '2-car garage (2 bays)' },
        { id: 'D', text: '3-car garage or larger' }
      ], multi: false
    },
    Q3_APT: {
      text: 'What floor is your unit on?',
      options: [
        { id: 'A', text: 'Ground floor' },
        { id: 'B', text: 'Second floor or higher' }
      ], multi: false
    },
    Q3_MOB: {
      text: 'Does your home have a storage shed or detached structure attached by a walkway?',
      options: [
        { id: 'A', text: 'Yes' },
        { id: 'B', text: 'No' }
      ], multi: false
    },
    Q4: {
      text: 'How many exterior doors enter directly into your home\u2019s finished living space?',
      options: [
        { id: 'A', text: '1 exterior door' },
        { id: 'B', text: '2 exterior doors' },
        { id: 'C', text: '3 or more exterior doors' }
      ], multi: false
    },
    Q4B: {
      text: 'How many of those exterior doors open directly into a kitchen, pantry, mudroom, or laundry room?',
      options: [
        { id: 'NONE', text: 'None of them open into one of these rooms' },
        { id: '1', text: '1 door opens into one of these rooms' },
        { id: '2', text: '2 doors open into one of these rooms' },
        { id: '3', text: '3 or more doors open into one of these rooms' }
      ], multi: false,
      filterOptions: function(state) {
        var q4 = state.answers.Q4;
        var maxDoors = q4 === 'A' ? 1 : (q4 === 'B' ? 2 : (q4 === 'C' ? 3 : 0));
        return function(opt) {
          if (opt.id === 'NONE') return true;
          if (opt.id === '1') return maxDoors >= 1;
          if (opt.id === '2') return maxDoors >= 2;
          if (opt.id === '3') return maxDoors >= 3;
          return false;
        };
      }
    },
    Q4_APT: {
      text: 'How many exterior-facing windows do you have in your unit?',
      options: [
        { id: 'A', text: '1\u20132 windows' },
        { id: 'B', text: '3\u20135 windows' },
        { id: 'C', text: '6 or more windows' }
      ], multi: false
    },
    Q4_MOB: {
      text: 'How many exterior doors does your home have?',
      options: [
        { id: 'A', text: '1 door' },
        { id: 'B', text: '2 doors' },
        { id: 'C', text: '3 or more doors' }
      ], multi: false
    },
    Q5_APT: {
      text: 'How many rooms are in your unit (not counting bathrooms)?',
      options: [
        { id: 'A', text: '1\u20133 rooms' },
        { id: 'B', text: '4\u20136 rooms' },
        { id: 'C', text: '7 or more rooms' }
      ], multi: false
    },
    Q5_MOB: {
      text: 'How would you describe the layout of your home?',
      options: [
        { id: 'A', text: 'Open plan \u2014 kitchen, living, and dining are all connected' },
        { id: 'B', text: 'Separated rooms with hallways' }
      ], multi: false
    },
    Q6: {
      text: 'Do you have a basement?',
      options: [
        { id: 'A', text: 'No basement' },
        { id: 'B', text: 'Unfinished basement (storage, utilities)' },
        { id: 'C', text: 'Finished basement (living space, bedroom, or office)' }
      ], multi: false
    },
    Q7: {
      text: 'On your ground floor, how many of the following rooms do you have: kitchen, pantry, mudroom, laundry room?',
      options: [
        { id: 'A', text: '1 of these rooms' },
        { id: 'B', text: '2 of these rooms' },
        { id: 'C', text: '3 of these rooms' },
        { id: 'D', text: 'All 4 of these rooms' }
      ], multi: false
    }
  };

  var TEMPLATES = {
    ACTIVE: {
      headline: "You've seen the signs. Here's how to take your home back.",
      body: 'Your [N]-device plan covers the entry points they\'re using and the rooms where they settle. Plug in the garage and entry-door devices first to cut off new arrivals, then put one on the kitchen wall closest to the stove or pantry \u2014 behind appliances is where they nest. The extra device goes in the room where you\'ve seen droppings or activity.',
      flag: ''
    },
    PREV_HIST: {
      headline: "You know what this looks like. Here's how to make sure it doesn't happen again.",
      body: 'Your [N]-device plan is built around the entry points most likely to let mice back in. The garage and entry doors are your first line of defense, so plug those in first. Your prior experience is actually useful here: think about where you found evidence last time and prioritize that zone.',
      flag: ''
    },
    PREV_NEW: {
      headline: "Prevention is easier than remediation. Here's your starting point.",
      body: "Your [N]-device plan focuses on the entry points that account for the majority of mouse intrusions: the garage (if you have one) and the exterior doors. You don't need full interior coverage yet \u2014 perimeter protection is the right first investment.",
      flag: ''
    },
    CHRONIC: {
      headline: "If what you've tried before isn't working, placement is probably the issue \u2014 not the product.",
      body: "Most devices fail because they're placed in rooms mice are already comfortable in, not at the entry points where they make the decision to stay. Your [N]-device plan is built around the perimeter-first principle: garage and entry door placements come first, kitchen and interior coverage second. The goal is to make your home uninviting before they settle \u2014 not after.",
      flag: ''
    },
    APT_GROUND: {
      headline: 'Two devices, two zones. Here\'s where they go.',
      body: "Device 1: Near your unit's entry door \u2014 the gap at the bottom of the door is the most common entry point in apartment units. Device 2: Kitchen or pantry \u2014 the settlement target if something gets in.",
      flag: ''
    },
    APT_UPPER: {
      headline: 'Upper floor units have fewer entry vectors. One or two devices cover your exposure.',
      body: "Primary placement: kitchen or living area. If you have a second device, place it near your unit's front door. Shared walls are your main vulnerability \u2014 seal any visible pipe or cable penetrations with steel wool or foam.",
      flag: ''
    },
    MOBILE: {
      headline: "The foundation gap is the biggest risk. Here's how to cover it.",
      body: 'Mobile and manufactured homes have unique entry vulnerabilities at the pier foundation perimeter. Device 1: Entry door zone. Device 2: Kitchen. Device 3 (if separated rooms): Hallway midpoint to create a signal corridor between zones.',
      flag: 'Pier foundation gaps are an exclusion priority \u2014 skirting seal or hardware cloth around the base perimeter is the highest-leverage parallel action.'
    }
  };

  /* Quiz recommends 1–15 devices. Map directly to the matching variant via window.VARIANT_MAP_BY_COUNT (rendered in Liquid). */
  var MAX_VARIANT_PACK = 15;

  /* ── RATIONALE ENGINE ── */
  /* Each question maps to a function that returns an array of tally items:
     { zone: string, count: number, reason: string, type: 'add'|'neutral'|'info' } */
  var RATIONALES = {
    Q1: function(a) {
      var map = {
        A: { zone: 'Active problem detected', count: 0, reason: 'We\'ll prioritize entry points and the zone where you\'re seeing activity.', type: 'info' },
        B: { zone: 'Prevention mode', count: 0, reason: 'You\'ve dealt with this before. We\'ll focus on the entry points that let them in last time.', type: 'info' },
        C: { zone: 'Proactive protection', count: 0, reason: 'No current activity \u2014 we\'ll build perimeter coverage to keep it that way.', type: 'info' },
        D: { zone: 'Chronic problem', count: 0, reason: 'Previous methods failed. We\'ll rebuild coverage around entry points \u2014 placement is usually the issue.', type: 'info' }
      };
      return [map[a]];
    },
    Q_STATE: function(a) {
      var region = STATE_REGIONS[a] || 'midwest';
      var threat = REGION_THREATS[region];
      return [{ zone: threat.zone(a), count: 0, reason: threat.reason(a), type: threat.type }];
    },
    Q2: function(a) {
      var map = {
        A: { zone: 'Single-family home', count: 0, reason: 'Standalone homes have more entry vectors (garage, doors, foundation). Expect 3\u20136 devices.', type: 'info' },
        B: { zone: 'Townhouse / duplex', count: 0, reason: 'Shared walls add complexity. We\'ll cover your entry points and flag shared-wall risks.', type: 'info' },
        C: { zone: 'Apartment / condo', count: 0, reason: 'Units have fewer entry vectors. Typically 1\u20132 devices cover your exposure.', type: 'info' },
        D: { zone: 'Mobile / manufactured home', count: 0, reason: 'Pier foundations create unique gaps. Typically 2\u20133 devices needed.', type: 'info' }
      };
      return [map[a]];
    },
    Q3: function(a) {
      var map = {
        A: [{ zone: 'No garage', count: 0, reason: 'No garage means one fewer entry zone to cover.', type: 'neutral' }],
        B: [{ zone: 'Single-car garage', count: 2, reason: 'One device facing the garage door to repel rodents entering through the gap at the base. One at the door into your home to block the transition from garage to living space.', type: 'add' }],
        C: [{ zone: 'Two-car garage', count: 2, reason: 'Two devices covering both directions \u2014 one facing the garage doors where rodents enter through gaps at the base, one facing the human door into the home to prevent them crossing into your living space.', type: 'add' }],
        D: [{ zone: 'Three+ car garage', count: 3, reason: 'Larger garages need 3 devices: two covering the wider garage door span from different angles, plus one at the door into your home. More bay area means more gap surface for rodents to exploit.', type: 'add' }]
      };
      return map[a];
    },
    Q3_APT: function(a) {
      if (a === 'A') {
        return [{ zone: 'Ground-floor unit', count: 2, reason: 'Ground floor units have the highest entry risk \u2014 one device at your entry door (gap at the bottom is the #1 entry point) and one in the kitchen.', type: 'add' }];
      }
      return [{ zone: 'Upper-floor unit', count: 0, reason: 'Upper floors have fewer direct entry vectors. We\'ll determine your count based on unit size.', type: 'info' }];
    },
    Q3_MOB: function(a) {
      if (a === 'A') {
        return [{ zone: 'Attached shed / structure', count: 1, reason: 'Connected structures create a sheltered pathway for rodents. One device at the walkway junction blocks this route.', type: 'add' }];
      }
      return [{ zone: 'No attached structures', count: 0, reason: 'No connected outbuildings \u2014 one fewer pathway to cover.', type: 'neutral' }];
    },
    Q4: function(a) {
      var map = {
        A: [{ zone: 'Exterior door', count: 1, reason: 'One device near your exterior door. Door frames and thresholds are primary entry points \u2014 even small gaps let mice through.', type: 'add' }],
        B: [{ zone: 'Exterior doors (\u00d72)', count: 2, reason: 'One device per door. Each exterior door is an independent entry vector \u2014 mice test every gap, so every door needs coverage.', type: 'add' }],
        C: [{ zone: 'Exterior doors (\u00d73+)', count: 3, reason: 'One device per door. With 3+ entry points, perimeter coverage is critical \u2014 uncovered doors become the path of least resistance.', type: 'add' }]
      };
      return map[a];
    },
    Q4_APT: function(a) {
      return [{ zone: 'Windows assessed', count: 0, reason: 'Window count noted. Apartments with more exterior exposure may need additional coverage \u2014 we\'ll factor this into your room count.', type: 'info' }];
    },
    Q4_MOB: function(a) {
      var map = {
        A: [{ zone: 'Entry door', count: 0, reason: 'Entry door zone will be covered. Factored into your layout-based count next.', type: 'info' }],
        B: [{ zone: 'Entry doors (\u00d72)', count: 0, reason: 'Two doors noted. Your layout determines total device placement.', type: 'info' }],
        C: [{ zone: 'Entry doors (3+)', count: 0, reason: 'Multiple doors noted. We\'ll account for this in your layout coverage.', type: 'info' }]
      };
      return map[a];
    },
    Q4B: function(a) {
      var map = {
        NONE: [{ zone: 'No overlap caught', count: 0, reason: 'None of your exterior doors open into a kitchen, pantry, mudroom, or laundry room \u2014 your door devices and your destination-room devices are separate placements. Your count stands.', type: 'neutral' }],
        '1': [{ zone: 'Overlap caught \u2014 1 device removed', count: -1, reason: 'One of your exterior doors opens directly into a kitchen, pantry, mudroom, or laundry room. The door device and the room device are the same physical placement, so we removed 1 device from your plan. We\u2019d rather catch this now than have you buy a device you don\u2019t need.', type: 'dedup' }],
        '2': [{ zone: 'Overlap caught \u2014 2 devices removed', count: -2, reason: 'Two of your exterior doors open directly into a kitchen, pantry, mudroom, or laundry room. Each one is a single placement that covers both the door and the room, so we removed 2 devices from your plan. We\u2019d rather catch this now than have you buy devices you don\u2019t need.', type: 'dedup' }],
        '3': [{ zone: 'Overlap caught \u2014 3 devices removed', count: -3, reason: 'Three of your exterior doors open directly into a kitchen, pantry, mudroom, or laundry room. Each one is a single placement that covers both the door and the room, so we removed 3 devices from your plan. We\u2019d rather catch this now than have you buy devices you don\u2019t need.', type: 'dedup' }]
      };
      return map[a];
    },
    Q5_APT: function(a) {
      if (state.answers.Q3_APT === 'B') {
        var ct = a === 'A' ? 1 : 2;
        return [{ zone: 'Unit rooms', count: ct, reason: ct === 1 ? 'Smaller upper-floor unit \u2014 one device in the kitchen or main living area covers your exposure.' : 'Larger upper-floor unit needs 2 devices to ensure signal reaches all rooms.', type: 'add' }];
      }
      return [{ zone: 'Room count noted', count: 0, reason: 'Your ground-floor entry coverage is already set. Room count helps confirm placement priority.', type: 'info' }];
    },
    Q5_MOB: function(a) {
      if (a === 'A') {
        return [{ zone: 'Open-plan layout', count: 2, reason: 'Open layouts need 2 devices: one at the entry door zone and one in the kitchen. Signal carries well across open space.', type: 'add' }];
      }
      return [{ zone: 'Separated layout', count: 3, reason: 'Separated rooms with hallways need 3 devices: entry door, kitchen, and a hallway midpoint to create a continuous signal corridor between zones.', type: 'add' }];
    },
    Q6: function(a) {
      var map = {
        A: [{ zone: 'No basement', count: 0, reason: 'No basement means no below-grade entry to cover.', type: 'neutral' }],
        B: [{ zone: 'Unfinished basement', count: 1, reason: 'Unfinished basements have exposed utility penetrations (pipes, wires, vents) that rodents use as highways. One device near the utility entry area.', type: 'add' }],
        C: [{ zone: 'Finished basement', count: 2, reason: 'Finished basements are both entry zones and living space. One device near the utility/entry area, one in the main living section to ensure full coverage.', type: 'add' }]
      };
      return map[a];
    },
    Q7: function(a) {
      var map = {
        A: [{ zone: 'Destination rooms (\u00d71)', count: 1, reason: 'One device in your one target room (most likely the kitchen). It\'s the only ground-floor room mice have a reason to enter \u2014 formal living and dining rooms with no food are transit zones, not settlement targets.', type: 'add' }],
        B: [{ zone: 'Destination rooms (\u00d72)', count: 2, reason: 'Two devices, one in each of your two target rooms. Ultrasonic doesn\'t cross walls \u2014 but you don\'t need it to. Mice only settle where the food and soft material are. Cover those rooms and the rest of the floor takes care of itself.', type: 'add' }],
        C: [{ zone: 'Destination rooms (\u00d73)', count: 3, reason: 'Three devices, one in each of your three target rooms. Each device covers its room and the doorway in/out, so mice can\'t cross into a target room without hitting the field. We don\'t place devices in formal rooms because mice don\'t loiter where there\'s nothing to eat.', type: 'add' }],
        D: [{ zone: 'Destination rooms (\u00d74)', count: 4, reason: 'Four devices, one in each of your kitchen, pantry, mudroom, and laundry. With all four target rooms present, every food and nesting source on the ground floor needs its own coverage \u2014 ultrasonic can\'t cross the walls between them.', type: 'add' }]
      };
      var items = map[a].slice();
      if (state.path === 'ACTIVE') {
        items.push({ zone: 'Active-sighting device', count: 1, reason: 'You\u2019ve already seen signs, so we add one device for the room where you saw them.', type: 'add' });
      }
      return items;
    }
  };

  /* ── STATE THREAT DATA ── */
  var STATE_REGIONS = {
    // Northeast
    'Connecticut': 'northeast', 'Delaware': 'northeast', 'Maine': 'northeast', 'Maryland': 'northeast',
    'Massachusetts': 'northeast', 'New Hampshire': 'northeast', 'New Jersey': 'northeast', 'New York': 'northeast',
    'Pennsylvania': 'northeast', 'Rhode Island': 'northeast', 'Vermont': 'northeast', 'District of Columbia': 'northeast',
    // Southeast
    'Alabama': 'southeast', 'Arkansas': 'southeast', 'Florida': 'southeast', 'Georgia': 'southeast',
    'Kentucky': 'southeast', 'Louisiana': 'southeast', 'Mississippi': 'southeast', 'North Carolina': 'southeast',
    'South Carolina': 'southeast', 'Tennessee': 'southeast', 'Virginia': 'southeast', 'West Virginia': 'southeast',
    // Midwest
    'Illinois': 'midwest', 'Indiana': 'midwest', 'Iowa': 'midwest', 'Kansas': 'midwest',
    'Michigan': 'midwest', 'Minnesota': 'midwest', 'Missouri': 'midwest', 'Nebraska': 'midwest',
    'North Dakota': 'midwest', 'Ohio': 'midwest', 'South Dakota': 'midwest', 'Wisconsin': 'midwest',
    // South/Southwest
    'Arizona': 'southwest', 'New Mexico': 'southwest', 'Oklahoma': 'southwest', 'Texas': 'southwest',
    // Mountain/West
    'Colorado': 'mountain', 'Idaho': 'mountain', 'Montana': 'mountain', 'Nevada': 'mountain',
    'Utah': 'mountain', 'Wyoming': 'mountain',
    // Pacific
    'Alaska': 'pacific', 'California': 'pacific', 'Hawaii': 'pacific', 'Oregon': 'pacific', 'Washington': 'pacific'
  };

  var REGION_THREATS = {
    northeast: {
      zone: function(s) { return s + ' \u2014 High Threat Region'; },
      reason: function(s) { return s + ' sits in one of the densest rodent pressure zones in the country. Aging housing stock \u2014 especially homes built before 1980 \u2014 has foundation cracks, deteriorated weatherstripping, and utility gaps that mice are actively exploiting right now. A single female in your walls produces up to 80 offspring per year. The gap between \u201cI think I heard something\u201d and \u201cI have a colony\u201d is measured in weeks, not months. Every day without coverage is a day they\u2019re breeding unchecked.'; },
      type: 'info'
    },
    southeast: {
      zone: function(s) { return s + ' \u2014 Year-Round Active Threat'; },
      reason: function(s) { return 'Unlike northern states, ' + s + ' never gets cold enough to kill rodent populations outdoors. They breed 12 months a year \u2014 right now, tonight, a mouse is testing your home\u2019s perimeter for entry. Roof rats are especially aggressive in ' + s + ', entering through attic vents and roofline gaps most homeowners never think to check. Humidity is also silently rotting your door frames and siding, creating new entry points that didn\u2019t exist last year. There is no off-season here. The threat is active today.'; },
      type: 'info'
    },
    midwest: {
      zone: function(s) { return s + ' \u2014 Peak Migration Zone'; },
      reason: function(s) { return s + ' sits in the highest-volume rodent migration corridor in the country. Homes near farmland, open lots, or wooded areas are under constant pressure \u2014 field mice don\u2019t wait for an invitation. They\u2019re probing your foundation, garage seals, and utility penetrations right now, looking for the path of least resistance into a heated structure with food and water. A single entry point left uncovered for two weeks is enough to establish a breeding colony. By the time you find droppings, you\u2019re already behind.'; },
      type: 'info'
    },
    southwest: {
      zone: function(s) { return s + ' \u2014 Desert Rodent Corridor'; },
      reason: function(s) { return 'Your home in ' + s + ' is the most attractive structure for miles \u2014 it has water, shade, and food. Roof rats, pack rats, and house mice are all actively targeting it. Desert species are smaller and more agile than northern mice, squeezing through gaps as small as a dime. Right now, they\u2019re testing your garage door seals, AC line penetrations, and dryer vents. By the time you find droppings, they\u2019ve already mapped every food and water source in your home. Waiting means they\u2019re settling in deeper.'; },
      type: 'info'
    },
    mountain: {
      zone: function(s) { return s + ' \u2014 Altitude Pressure Zone'; },
      reason: function(s) { return 'Homes in ' + s + ' see heavy pressure from deer mice, the dominant species at elevation. They\u2019re more resourceful than lowland house mice \u2014 they climb vertical surfaces and enter through second-story gaps most homeowners never inspect. Your home\u2019s warmth is the strongest signal for miles, and every gap in your foundation, garage seal, or roofline is being actively tested. This isn\u2019t a seasonal risk \u2014 deer mice seek shelter year-round, and every day without protection is a day they\u2019re finding their way in.'; },
      type: 'info'
    },
    pacific: {
      zone: function(s) { return s + ' \u2014 Multi-Species Threat Zone'; },
      reason: function(s) { return s + ' homes face simultaneous pressure from house mice, Norway rats, and roof rats \u2014 all competing to get inside your walls right now. There is no winter die-off here: populations build continuously, year over year, compounding every month you go without protection. Older homes with crawl spaces are especially exposed \u2014 sub-floor gaps give rodents direct, hidden access to your kitchen and bathroom plumbing walls. Roof rats enter through attic vents and travel downward through wall cavities. By the time you hear them, they\u2019re already nesting.'; },
      type: 'info'
    }
  };

  // Read by the page's quiz_state_selected tracking (region param).
  window.RODENTRX_STATE_REGIONS = STATE_REGIONS;

  var _detectedState = null;

  var state = { path: null, home: null, answers: {}, history: [], currentQ: 'Q1', multiSelected: [], tallyItems: [] };

  // Flooring and evidence-location questions removed 2026-10-28 (Matt, #2).
  function getTotalSteps() {
    return (state.home === 'APT' || state.home === 'MOBILE') ? 6 : 8;
  }

  function getNextQ(qId) {
    var a = state.answers[qId];
    switch (qId) {
      case 'Q1':
        state.path = { A: 'ACTIVE', B: 'PREV_HIST', C: 'PREV_NEW', D: 'CHRONIC' }[a];
        return 'Q_STATE';
      case 'Q_STATE':
        return 'Q2';
      case 'Q2':
        state.home = { A: 'SFH', B: 'TOWNHOUSE', C: 'APT', D: 'MOBILE' }[a];
        if (a === 'C') return 'Q3_APT';
        if (a === 'D') return 'Q3_MOB';
        return 'Q3';
      case 'Q3': return 'Q6';
      case 'Q3_APT': return 'Q4_APT';
      case 'Q3_MOB': return 'Q4_MOB';
      case 'Q6': return 'Q4';
      case 'Q4': return 'Q4B';
      case 'Q4B': return 'Q7';
      case 'Q4_APT': return 'Q5_APT';
      case 'Q4_MOB': return 'Q5_MOB';
      case 'Q5_APT': return 'RECOMMEND';
      case 'Q5_MOB': return 'RECOMMEND';
      case 'Q7': return 'RECOMMEND';
      default: return 'RECOMMEND';
    }
  }

  function computeDeviceCount() {
    var a = state.answers;
    if (state.home === 'APT') {
      return a.Q3_APT === 'A' ? 2 : (a.Q5_APT === 'A' ? 1 : 2);
    }
    if (state.home === 'MOBILE') {
      var shed = a.Q3_MOB === 'A' ? 1 : 0;
      var layout = a.Q5_MOB === 'A' ? 2 : 3;
      return shed + layout;
    }
    var garage = { A: 0, B: 2, C: 2, D: 3 }[a.Q3] || 0;
    var doors = { A: 1, B: 2, C: 3 }[a.Q4] || 0;
    var dedup = { NONE: 0, '1': 1, '2': 2, '3': 3 }[a.Q4B] || 0;
    var basement = { A: 0, B: 1, C: 2 }[a.Q6] || 0;
    var gf = { A: 1, B: 2, C: 3, D: 4 }[a.Q7] || 0;
    var active = state.path === 'ACTIVE' ? 1 : 0;
    var total = garage + doors + basement + gf + active - dedup;
    return Math.max(1, total);
  }

  function getTemplateKey() {
    var a = state.answers;
    if (state.home === 'APT') return a.Q3_APT === 'A' ? 'APT_GROUND' : 'APT_UPPER';
    if (state.home === 'MOBILE') return 'MOBILE';
    if (state.path === 'ACTIVE') return 'ACTIVE';
    if (state.path === 'PREV_HIST') return 'PREV_HIST';
    if (state.path === 'PREV_NEW') return 'PREV_NEW';
    return 'CHRONIC';
  }

  function getVariantForCount(count) {
    var map = window.VARIANT_MAP_BY_COUNT || {};
    var clamped = Math.max(1, Math.min(MAX_VARIANT_PACK, count));
    // Exact match first; fall back to highest available pack
    if (map[clamped]) return map[clamped];
    for (var i = clamped; i >= 1; i--) {
      if (map[i]) return map[i];
    }
    return { id: null, sku: '', price: '', label: clamped + '-Pack' };
  }

  /* ── PERSONALIZED CTA BUILDER (#16) ── */
  function buildPersonalizedCTA(count) {
    var zones = [];
    var a = state.answers;
    if (state.home === 'APT') {
      zones.push('entry door');
      zones.push('kitchen');
    } else if (state.home === 'MOBILE') {
      zones.push('entry');
      zones.push('kitchen');
      if (a.Q3_MOB === 'A') zones.push('shed');
    } else {
      if (a.Q3 && a.Q3 !== 'A') zones.push('garage');
      if (a.Q4) zones.push(a.Q4 === 'A' ? 'entry door' : 'entry doors');
      if (a.Q6 && a.Q6 !== 'A') zones.push('basement');
      if (a.Q7) zones.push('ground floor');
    }
    // Build the zone string — pick up to 3 zones for readability
    var zoneStr = '';
    if (zones.length > 0) {
      var show = zones.slice(0, 3);
      zoneStr = show.join(' + ');
    }
    if (zoneStr) {
      return 'Get My ' + count + '-Device ' + zoneStr.charAt(0).toUpperCase() + zoneStr.slice(1) + ' Plan';
    }
    return 'Get My ' + count + '-Device Coverage Plan';
  }

  /* ── PROGRESSIVE VALUE DELIVERY (#17) ── */
  /* Milestones injected into the tally panel at key quiz moments */
  var MILESTONES = {
    // After Q3/Q3_APT/Q3_MOB — first structural data captured
    afterStructure: function() {
      var homeLabel = { SFH: 'single-family home', TOWNHOUSE: 'townhouse', APT: 'apartment', MOBILE: 'mobile home' }[state.home] || 'home';
      var riskLevel = (state.path === 'ACTIVE' || state.path === 'CHRONIC') ? 'high' : 'moderate';
      var riskColor = riskLevel === 'high' ? 'higher than average' : 'moderate';
      return {
        label: 'Early insight unlocked',
        text: 'Your ' + homeLabel + ' profile puts you at ' + riskColor + ' rodent risk. We\'re building your plan around your specific entry points \u2014 not a generic recommendation.'
      };
    },
    // After Q6 or Q5_APT/Q5_MOB — interior layout captured
    afterInterior: function() {
      var count = 0;
      state.tallyItems.forEach(function(it) { count += it.count; });
      if (count === 0) return null;
      var pct = Math.min(92, Math.max(71, 60 + count * 5));
      return {
        label: 'Coverage building',
        text: count + (count === 1 ? ' device' : ' devices') + ' locked in so far \u2014 covering ' + pct + '% of your home\'s primary entry vectors. A few more details to finalize.'
      };
    }
  };

  // Track which milestones have been shown to avoid duplicates
  state.milestonesShown = {};

  function checkMilestones(qId) {
    var listEl = document.getElementById('quiz-tally-list');
    var itemsEl = listEl.querySelector('.quiz-tally-items');
    if (!itemsEl) return;

    // Milestone 1: after first structural question
    if ((qId === 'Q3' || qId === 'Q3_APT' || qId === 'Q3_MOB') && !state.milestonesShown.afterStructure) {
      var m = MILESTONES.afterStructure();
      if (m) {
        var div = document.createElement('div');
        div.className = 'quiz-tally-milestone';
        div.setAttribute('data-milestone', 'afterStructure');
        div.innerHTML = '<div class="quiz-tally-milestone-label">' + m.label + '</div><div class="quiz-tally-milestone-text">' + m.text + '</div>';
        itemsEl.appendChild(div);
        itemsEl.scrollTop = itemsEl.scrollHeight;
        state.milestonesShown.afterStructure = true;
      }
    }

    // Milestone 2: after interior layout question
    if ((qId === 'Q6' || qId === 'Q5_APT' || qId === 'Q5_MOB') && !state.milestonesShown.afterInterior) {
      var m2 = MILESTONES.afterInterior();
      if (m2) {
        var div2 = document.createElement('div');
        div2.className = 'quiz-tally-milestone';
        div2.setAttribute('data-milestone', 'afterInterior');
        div2.innerHTML = '<div class="quiz-tally-milestone-label">' + m2.label + '</div><div class="quiz-tally-milestone-text">' + m2.text + '</div>';
        itemsEl.appendChild(div2);
        itemsEl.scrollTop = itemsEl.scrollHeight;
        state.milestonesShown.afterInterior = true;
      }
    }
  }

  function removeMilestonesAfter(qId) {
    // If user goes back past a milestone trigger, remove it
    var structureTriggers = ['Q3', 'Q3_APT', 'Q3_MOB'];
    var interiorTriggers = ['Q6', 'Q5_APT', 'Q5_MOB'];
    if (structureTriggers.indexOf(qId) !== -1) {
      state.milestonesShown.afterStructure = false;
      var el = document.querySelector('[data-milestone="afterStructure"]');
      if (el) el.remove();
    }
    if (interiorTriggers.indexOf(qId) !== -1) {
      state.milestonesShown.afterInterior = false;
      var el2 = document.querySelector('[data-milestone="afterInterior"]');
      if (el2) el2.remove();
    }
  }

  /* ── TALLY RENDERING ── */
  function updateTally() {
    var totalCount = 0;
    state.tallyItems.forEach(function(item) { totalCount += item.count; });
    if (totalCount < 0) totalCount = 0;

    var countEl = document.getElementById('quiz-tally-count');
    var prevCount = parseInt(countEl.textContent, 10);
    if (isNaN(prevCount)) prevCount = 0;

    if (totalCount < prevCount) {
      // Count is going down — animate a ticking countdown + flash
      countEl.classList.remove('flash-down');
      void countEl.offsetWidth;
      countEl.classList.add('flash-down');
      var current = prevCount;
      var step = function() {
        current -= 1;
        if (current <= totalCount) {
          countEl.textContent = totalCount;
          return;
        }
        countEl.textContent = current;
        setTimeout(step, 140);
      };
      setTimeout(step, 140);
    } else {
      countEl.textContent = totalCount;
      countEl.classList.add('bump');
      setTimeout(function() { countEl.classList.remove('bump'); }, 300);
    }

    var listEl = document.getElementById('quiz-tally-list');
    if (state.tallyItems.length === 0) {
      listEl.innerHTML = '<div class="quiz-tally-empty">Answer the first question to start building your plan.</div>';
      return;
    }

    var html = '<div class="quiz-tally-items">';
    state.tallyItems.forEach(function(item) {
      var badgeClass = item.type;
      var badgeText;
      if (item.count > 0) badgeText = '+' + item.count;
      else if (item.count < 0) badgeText = '\u2212' + Math.abs(item.count);
      else badgeText = (item.type === 'info' ? '\u2139' : '\u2013');
      var itemClass = 'quiz-tally-item' + (item.type === 'dedup' ? ' dedup-row' : '');
      html += '<div class="' + itemClass + '">' +
        '<div class="quiz-tally-badge ' + badgeClass + '">' + badgeText + '</div>' +
        '<div class="quiz-tally-detail">' +
          '<div class="quiz-tally-zone">' + item.zone + '</div>' +
          '<div class="quiz-tally-reason">' + item.reason + '</div>' +
        '</div>' +
      '</div>';
    });
    html += '</div>';
    listEl.innerHTML = html;

    // scroll tally items to bottom to show latest
    var itemsEl = listEl.querySelector('.quiz-tally-items');
    if (itemsEl) itemsEl.scrollTop = itemsEl.scrollHeight;
  }

  function addTallyItems(qId) {
    var fn = RATIONALES[qId];
    if (!fn) return;
    var answer = state.answers[qId];
    var items = fn(answer);
    if (items && items.length > 0) {
      // tag items with source question so we can remove on back
      items.forEach(function(it) { it._source = qId; });
      state.tallyItems = state.tallyItems.concat(items);
      updateTally();
    }
  }

  function removeTallyItemsFrom(qId) {
    state.tallyItems = state.tallyItems.filter(function(it) { return it._source !== qId; });
    updateTally();
  }

  var INSIGHTS = {
    Q3: function() {
      var map = { A: 'Single-family homes typically need 3\u20136 devices.', B: 'Townhouses typically need 3\u20135 devices.', C: 'Apartments typically need 1\u20132 devices.', D: 'Mobile homes typically need 2\u20133 devices.' };
      var h = state.answers.Q2;
      return h ? (map[h] || '') + " A few more questions to lock in your exact count." : '';
    },
    Q3_APT: function() { return 'Apartments typically need 1\u20132 devices. Your floor affects signal reach \u2014 that\'s what this question covers.'; },
    Q3_MOB: function() { return 'Mobile homes typically need 2\u20133 devices. One more structural detail to confirm your count.'; },
    Q4: function() { return 'Don\u2019t count exterior doors that open into the garage \u2014 those are already covered by the garage devices. But do count the door from the garage into your house if you have an attached garage.'; },
    Q4B: function() { return 'We don\'t want to recommend two devices for the same physical spot. If a destination room sits behind one of the doors you just counted, one device covers both.'; },
    Q7: function() { return 'Mice only settle in rooms that give them what they need: food (kitchen, pantry, pet feeding areas) or soft nesting material (mudroom, laundry). Formal living and dining rooms with no food draw are transit zones, not destinations \u2014 mice don\'t loiter there, so we don\'t place devices in them. We place one device in each of these target rooms.'; }
  };

  function renderQuestion(qId) {
    state.currentQ = qId;
    var q = QUESTIONS[qId];
    document.getElementById('quiz-question').textContent = q.text;

    var insightEl = document.getElementById('quiz-insight');
    var insightFn = INSIGHTS[qId];
    var insightText = insightFn ? insightFn() : '';
    if (insightText) { insightEl.textContent = insightText; insightEl.style.display = 'block'; }
    else { insightEl.style.display = 'none'; }

    var optHtml = '';
    var nextBtn = document.getElementById('quiz-next');

    if (q.type === 'dropdown') {
      // State dropdown rendering
      var detected = _detectedState;
      var currentVal = state.answers[qId] || detected || '';
      if (detected) {
        optHtml += '<div class="quiz-state-detected">Based on your location: <strong>' + detected + '</strong></div>';
      }
      optHtml += '<div class="quiz-state-wrap">';
      optHtml += '<select class="quiz-state-select' + (currentVal ? ' selected' : '') + '" id="quiz-state-dropdown" onchange="quizSelectState(this)">';
      optHtml += '<option value="">Select your state...</option>';
      q.options.forEach(function(st) {
        var sel = st === currentVal ? ' selected' : '';
        optHtml += '<option value="' + st + '"' + sel + '>' + st + '</option>';
      });
      optHtml += '</select></div>';
      document.getElementById('quiz-options').innerHTML = optHtml;

      // If we have a pre-filled value, store it
      if (currentVal && !state.answers[qId]) {
        state.answers[qId] = currentVal;
      }

      // Show continue button for dropdown
      nextBtn.style.display = 'inline-flex';
      nextBtn.disabled = !currentVal;
    } else {
      var filterFn = typeof q.filterOptions === 'function' ? q.filterOptions(state) : null;
      q.options.forEach(function(opt) {
        if (filterFn && !filterFn(opt)) return;
        var sel = q.multi
          ? (state.multiSelected.indexOf(opt.id) !== -1 ? ' selected' : '')
          : (state.answers[qId] === opt.id ? ' selected' : '');
        optHtml += '<button class="quiz-option' + sel + '" data-qid="' + qId + '" data-oid="' + opt.id + '" onclick="quizSelectOption(this,' + (q.multi ? 'true' : 'false') + ')"><span class="quiz-option-text">' + opt.text + '</span><span class="quiz-option-chevron">\u203a</span></button>';
      });
      document.getElementById('quiz-options').innerHTML = optHtml;

      if (q.multi) {
        nextBtn.style.display = 'inline-flex';
        nextBtn.disabled = state.multiSelected.length === 0;
      } else {
        nextBtn.style.display = 'none';
        nextBtn.disabled = true;
      }
    }

    var step = state.history.length + 1;
    var total = getTotalSteps();
    document.getElementById('quiz-progress-label').textContent = 'Step ' + step + ' of ' + total;
    document.getElementById('quiz-progress-fill').style.width = (Math.max(0, (step - 1) / total) * 100) + '%';

    var backBtn = document.getElementById('quiz-back');
    backBtn.style.display = state.history.length > 0 ? 'inline-flex' : 'none';
  }

  window.quizSelectOption = function(btn, isMulti) {
    var qId = btn.getAttribute('data-qid');
    var oId = btn.getAttribute('data-oid');
    if (isMulti) {
      var idx = state.multiSelected.indexOf(oId);
      if (idx === -1) { state.multiSelected.push(oId); btn.classList.add('selected'); }
      else { state.multiSelected.splice(idx, 1); btn.classList.remove('selected'); }
      document.getElementById('quiz-next').disabled = state.multiSelected.length === 0;
    } else {
      document.querySelectorAll('#quiz-options .quiz-option').forEach(function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      state.answers[qId] = oId;
      setTimeout(quizAdvance, 280);
    }
  };

  window.quizSelectState = function(sel) {
    var val = sel.value;
    if (val) {
      state.answers['Q_STATE'] = val;
      sel.classList.add('selected');
      document.getElementById('quiz-next').disabled = false;
    } else {
      delete state.answers['Q_STATE'];
      sel.classList.remove('selected');
      document.getElementById('quiz-next').disabled = true;
    }
  };

  window.quizNext = function() { quizAdvance(); };

  function quizAdvance() {
    var qId = state.currentQ;
    if (QUESTIONS[qId].multi) {
      state.answers[qId] = state.multiSelected.slice();
    }
    // Add rationale items for this answered question
    addTallyItems(qId);
    // Check for progressive value delivery milestones
    checkMilestones(qId);
    state.history.push(qId);
    var nextQ = getNextQ(qId);
    if (nextQ === 'RECOMMEND') {
      showResult();
    } else {
      state.multiSelected = Array.isArray(state.answers[nextQ]) ? state.answers[nextQ].slice() : [];
      renderQuestion(nextQ);
    }
  }

  window.quizBack = function() {
    if (state.history.length === 0) return;
    var prev = state.history.pop();
    // Remove tally items and milestones from the question we're going back to
    removeTallyItemsFrom(prev);
    removeMilestonesAfter(prev);
    state.multiSelected = Array.isArray(state.answers[prev]) ? state.answers[prev].slice() : [];
    renderQuestion(prev);
  };

  function showResult() {
    var count = computeDeviceCount();
    var tmpl = TEMPLATES[getTemplateKey()];
    var variantInfo = getVariantForCount(count);
    var body = tmpl.body.replace(/\[N\]/g, count);

    // One plain plug-in note on every page; the 1-3 day / 14-day timing note was removed 2026-10-29 (no source).
    var instantNote = '<div class="quiz-note"><strong>Keep every unit plugged in.</strong> RodentRx only works while it has power.</div>';
    var carpetNote = '<div class="quiz-note">Rooms mostly carpeted or heavily furnished? Add one more device: carpet and soft furnishings absorb ultrasonic signal.</div>';
    var sharedWall = state.home === 'TOWNHOUSE'
      ? '<div class="quiz-flag"><strong>Shared wall note:</strong> Devices protect your unit. Shared wall cavities are an exclusion problem \u2014 not a device problem. Seal shared wall penetrations (pipe entries, utility chases) for complete coverage.</div>' : '';

    // CTA — add the exact recommended variant to cart and go to checkout
    var ctaHtml = variantInfo.id
      ? '<button type="button" class="quiz-cta-btn" onclick="addToCartAndCheckout(' + variantInfo.id + ')">' + buildPersonalizedCTA(count) + ' &rarr;</button>'
      : '<a class="quiz-cta-btn" href=" + (window.PRODUCT_URL || "#") + " target="_blank">' + buildPersonalizedCTA(count) + ' &rarr;</a>';

    // Floor plan of where each unit goes: only pages that set RODENTRX_FLOORPLAN (landers B and C) show it.
    var planHtml = '';
    if (window.RODENTRX_FLOORPLAN && window.RodentRxFloorPlan) {
      try { planHtml = window.RodentRxFloorPlan.render(state, { deviceSrc: window.RODENTRX_FP_DEVICE_SRC }).html; } catch (e) { planHtml = ''; }
    }

    var html = '<div class="quiz-result-inner">' +
      '<div class="quiz-result-count-row">' +
        '<div class="quiz-device-count">' + count + '</div>' +
        '<div class="quiz-device-label">' + (count === 1 ? 'device' : 'devices') + ' recommended<span class="quiz-sku-label">' + variantInfo.label + ' &middot; SKU ' + variantInfo.sku + '</span></div>' +
      '</div>' +
      '<h3 class="quiz-result-headline">' + tmpl.headline + '</h3>' +
      '<p class="quiz-result-body">' + body + '</p>' +
      planHtml +
      instantNote +
      (tmpl.flag ? '<div class="quiz-flag">' + tmpl.flag + '</div>' : '') +
      sharedWall +
      carpetNote +
      ctaHtml +
      '<button class="quiz-retake-btn" onclick="quizRetake()">Retake the quiz</button>' +
    '</div>';

    document.getElementById('quiz-progress-fill').style.width = '100%';
    document.getElementById('quiz-card').style.display = 'none';
    var resultEl = document.getElementById('quiz-result');
    resultEl.innerHTML = html;
    resultEl.style.display = 'block';
  }

  window.quizRetake = function() {
    state = { path: null, home: null, answers: {}, history: [], currentQ: 'Q1', multiSelected: [], tallyItems: [], milestonesShown: {} };
    document.getElementById('quiz-result').style.display = 'none';
    document.getElementById('quiz-result').innerHTML = '';
    document.getElementById('quiz-card').style.display = 'block';
    updateTally();
    renderQuestion('Q1');
  };

  // IP geolocation — pre-fill state dropdown
  (function() {
    try {
      fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(3000) })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data && data.region && data.country_code === 'US') {
            _detectedState = data.region;
          }
        })
        .catch(function() { /* silent fail — user picks manually */ });
    } catch(e) { /* AbortSignal.timeout not supported — silent fail */ }
  })();

  renderQuestion('Q1');
})();